import { render, staticRenderFns } from "./id_card.vue?vue&type=template&id=21220428&scoped=true&"
import script from "./id_card.vue?vue&type=script&lang=js&"
export * from "./id_card.vue?vue&type=script&lang=js&"
import style0 from "./id_card.vue?vue&type=style&index=0&id=21220428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21220428",
  null
  
)

export default component.exports